import(/* webpackMode: "eager" */ "/opt/cal/apps/web/app/error.tsx");
